export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 11_04.c9f0aa8c.jpg";